import Link from "next/link";
import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { useDarkTheme } from "@/contexts/DarkTheme";
import { IoMdClose } from "react-icons/io";
import { useAppDetails } from "@/contexts/AppDetailsContext";
import { useRouter } from "next/router";

export default function headerMarketplace() {
  const { darkTheme } = useDarkTheme();
  let [showPopup, setShowPopup] = useState(true);
  const { details } = useAppDetails();
  const router = useRouter();

  const isDisclaimerPage =
    router?.pathname?.includes("marketplace") ||
    router?.pathname?.includes("prediction-market");

  return (
    <div className="lg:sticky lg:top-0 z-20">
      {isDisclaimerPage && showPopup && (
        <div className="p-[6px] pl-2 bg-[#3269CC] text-xs flex justify-between items-center">
          <div>
            These strategies are for educational purposes only, showcasing
            what's possible with Level2. Please conduct your own research before
            making any trading decisions.
          </div>
          <div
            onClick={() => setShowPopup(false)}
            className="cursor-pointer h-full bold flex justify-center items-center  pr-1"
          >
            <IoMdClose />
          </div>
        </div>
      )}

      <div className="flex  items-center justify-between ml-[2%] mr-[2%] pt-[10px] pb-[10px] bg-card ">
        {darkTheme ? (
          <img
            src={details?.brokerLogo ?? "/images/logos/Logo_Dark.png"}
            className="md:max-h-[30px] xs:max-h-[25px] max-h-[25px] sm:max-w-[300px]"
            alt=""
          />
        ) : (
          <img
            src="/images/logos/Logo_Light-2.png"
            className="md:max-h-[30px] xs:max-h-[25px] max-h-[25px] sm:max-w-[300px]"
            alt=""
          />
        )}

        <Link href={`/create-new-account`}>
          <Button className="flex items-center h-[34px]">Sign Up</Button>
        </Link>
      </div>
    </div>
  );
}
